import { render, staticRenderFns } from "./PgaValutazioneOffertaProgettoACorpoCreate.vue?vue&type=template&id=f6bcdcc0&"
import script from "./PgaValutazioneOffertaProgettoACorpoCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaProgettoACorpoCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6bcdcc0')) {
      api.createRecord('f6bcdcc0', component.options)
    } else {
      api.reload('f6bcdcc0', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaProgettoACorpoCreate.vue?vue&type=template&id=f6bcdcc0&", function () {
      api.rerender('f6bcdcc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaProgettoACorpoCreate.vue"
export default component.exports